
const chatRoute={
    path:'/chat',
    component:() => import(/* webpackChunkName: "user" */ '@/views/chat/index.vue')
}

export default chatRoute;